import { createAsyncThunk } from "@reduxjs/toolkit";
import { redeem_voucher } from "../../../../api/calls/voucher/redeem-voucher";
import { setMainModal } from "../../main";
export const redeem_voucher_thunk = createAsyncThunk("basket/redeem_voucher", async (arg, { dispatch, getState }) => {
    const state = getState();
    const { user } = state.userState;
    const basket_id = "";
    const redemption_id = "";
    const response = await redeem_voucher({
        basket_id,
        redemption_id,
        user_id: user.user._id,
    });
    if (response.success) {
        if (response.content == null) {
            // TODO: don't have all the answers yet as to what should happen here...
            //        will get back to this once we know.
            console.log(response?.content);
        }
    }
    else {
        dispatch(setMainModal({ title: "Something went wrong while applying your voucher!", messages: [response.message] }));
    }
    return response;
});
